var React = require('react');
import { Box, Container, Grid } from '@mui/material';
import MUIDataTable from 'mui-datatables';
import SearchIcon from "@material-ui/icons/Search";
import Button from "@mui/material/Button";
import SaveIcon from "@material-ui/icons/Save";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import { MuiThemeProvider } from '@material-ui/core/styles';
import Toolbar from '@mui/material/Toolbar';
import CloseIcon from '@mui/icons-material/Close';
import { muiThemeDesign } from '../../mui-theme-design';
import moment from "moment";
import { makeStyles } from "@mui/styles";
import Checkbox from '@mui/material/Checkbox';
import CheckIcon from '@mui/icons-material/Check';
import DoNotDisturbIcon from '@mui/icons-material/DoNotDisturb';
import ReportGmailerrorredIcon from '@mui/icons-material/ReportGmailerrorred';
import HandelSOWBillingReport from './HandelSOWBillingReport'
import HandelPOBillingReport from './HandelPOBillingReport'
import {logger, handleExport, customBodyForExcelReport,checkAuthentication,muiLoaderOptions} from '../../utils';

const pageStyles = makeStyles(theme => ({
    root: {
        "& .MuiPaper-root": {
            overflowy: "hidden",
            color: '#ffffff'
        },
        "& .Mui-checked": {
            color: '#ffffff'
        },
        "& .MuiCheckBox-root": {
            color: '#ffffff!important',
            fill: '#ffffff'
        },
        "& .MuiSvgIcon-root": {
            color: '#ffffff',
            fill: '#ffffff',
        },
        "& .MuiSvgIcon-error": {
            color: '#c40018',
            fill: '#c40018',
        },
        "& .MuiButton-root": {
            fontSize: "0.7rem"
        },
//.datatables-noprint
    },

}));

export default function ReportBillingSOW() {
    const [refresh, setRefresh] = React.useState(false);
    const [dataSet, setDataSet] = React.useState([]);
    const [open, setOpen] = React.useState(false);
    const [expand, setExpand] = React.useState(false);
    const [display, setDisplay] = React.useState(false);
    const [isLoading, setIsLoading] = React.useState(true);

    const classes = pageStyles();

    const getData = async () => {
    //    logger(`in getData`)
        await fetch(`/api/Reports/BillingSOW/${expand}`, {
       //     ${ expand }
            method: 'Get',
        })
            .then(res => res.json())
            .then(json => {
					setDataSet(json);
					setIsLoading(false);
				})

    };

    const columns = [
        {
            name: "Report",
            options: {
                filter: false,
                sort: false,
                customBodyRender: (value, tableMeta, updateValue) => {
                    return <HandelSOWBillingReport SOWID={dataSet[tableMeta.rowIndex].SOWID} name={dataSet[tableMeta.rowIndex].SOWShort} display={display} />
                }
            }
        },
        {
            name: "MGPT",
            label: "MGPT",
            options: {
                filter: true,
                sort: true,
                //    position: "sticky",
            }
        },
        {
            name: "SOWShort",
            label: "SOW",
            options: {
                filter: true,
                sort: true,
                //    position: "sticky",
            }
        },
        {
            name: "PoNumbers",
            label: "PO Number",
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value, tableMeta, updateValue) => {
                    //    logger(`value`, value);

                    if (value.includes("|")) {
                        //      logger(`IF value`, value);
                        return value.split("|").map((item, idx) => {
                            //        logger(`item`, item);
                            return (
                                <React.Fragment key={idx}>
                                    {item}
                                    <br />
                                </React.Fragment>
                            );
                        });
                    } else {
                        return <React.Fragment>{value}</React.Fragment>;
                    }
                }
            }
        },
        {
            name: "POShorts",
            label: "PO Name",
            options: {
                filter: false,
                sort: true,
                customBodyRender: (value, tableMeta, updateValue) => {
                    //    logger(`value`, value);

                    if (value.includes("|")) {
                        //      logger(`IF value`, value);
                        return value.split("|").map((item, idx) => {
                            //        logger(`item`, item);
                            return (
                                <React.Fragment key={idx}>
                                    {item}
                                    <br />
                                </React.Fragment>
                            );
                        });
                    } else {
                        return <React.Fragment>{value}</React.Fragment>;
					}
				}
			}
		},
		{
        name: "InvoiceNumbers",
        label: "Invoices",
        options: {
            filter: true,
            sort: true,
            customBodyRender: (value, tableMeta, updateValue) => {
                logger('InvoiceNumbers value:', value);
                if (value.includes("|")) {
                    return value.split("|").map((item, idx) => (
                        <React.Fragment key={idx}>
                            {item}
							<br />
						</React.Fragment>
					));
					} else {
						return <React.Fragment>{value}</React.Fragment>;
					}
				}
			}
		},
		{
			name: "InvoiceStartDates",
			label: "Invoice StartDates",
			options: {
				filter: true,
				sort: true,
				customBodyRender: (value, tableMeta, updateValue) => {
					const formatDate = (dateString) => {
						if (!dateString || !moment.utc(dateString).isValid()) {
							return "";
						}
						return moment.utc(dateString).format("MM/DD/YYYY"); 
					};


					if (value.includes("|")) {
						return value.split("|").map((item, idx) => {
							return (
								<React.Fragment key={idx}>
									{formatDate(item)}
									<br />
								</React.Fragment>
							);
						});
					} else {
						return <React.Fragment>{formatDate(value)}</React.Fragment>;
					}
				}
			}
		},
		{
			name: "InvoiceEndDates",
			label: "Invoice EndDates",
			options: {
				filter: true,
				sort: true,
				customBodyRender: (value, tableMeta, updateValue) => {
					const formatDate = (dateString) => {
						if (!dateString || !moment.utc(dateString).isValid()) {
							return ""; 
						}
						return moment.utc(dateString).format("MM/DD/YYYY");
					};
					if (value.includes("|")) {
						return value.split("|").map((item, idx) => {
							return (
								<React.Fragment key={idx}>
									{formatDate(item)}
									<br />
								</React.Fragment>
							);
						});
					} else {
						return <React.Fragment>{formatDate(value)}</React.Fragment>;
					}
				}
			}
		},

        {
            name: "Amounts",
            label: "Amounts",
            options: {
                filter: true,
                sort: true,
                //    position: "sticky",
                customBodyRender: (value, tableMeta, updateValue) => {
                //    logger(`value`, value);

                    if (value.includes("|")) {
                  //      logger(`IF value`, value);
                        return value.split("|").map((item, idx) => {
                    //        logger(`item`, item);
                            return (
                                <React.Fragment key={idx}>
                                    {item}
                                    <br />
                                </React.Fragment>
                            );
                        });
                    } else {
                        return <React.Fragment>{value}</React.Fragment>;
                    }
                }
            }
        },
    ];
    const MakeToolbar = () => {
        return (
            <>
                <Tooltip title="click to include InActive SOWs" placement="top-end">
                    <Checkbox className={classes.root} defaultChecked={expand} color="default" onClick={() => { setExpand(!expand), setRefresh(true); }} />
                </Tooltip>
                <Tooltip title="display username on download" placement="top-end">
                    <Checkbox className={classes.root} defaultChecked={display} color="default" onClick={() => { setDisplay(!display), setRefresh(true); }} />
                </Tooltip>
                </>
        );
        logger("createTB" + MakeToolbar)
    }

    const getSavedRowsPerPage = () => {
        const savedValue = localStorage.getItem('rowsPerPage');
        return savedValue ? parseInt(savedValue) : 100; // Default value
    }
    // Save to local storage
    const saveRowsPerPage = (value) => {
        localStorage.setItem('rowsPerPage', value.toString());
    }

    const initialRowsPerPage = getSavedRowsPerPage();

    const options = {
        filter: true,
        filterType: 'dropdown',
        responsive: 'vertical',
        fixedHeader: true,
        fixedSelectColumn: false,
        tableBodyHeight: "400px",
        tableBodyMaxHeight: "1000px",
        rowsPerPage: initialRowsPerPage,
        responsive: 'standard',
        rowsPerPageOptions: [10, 20, 50, 100],
        textLabels: {
		    toolbar: {
		      search: "Search",
		      downloadCsv: "Download Excel", 
		      print: "Print",
		      viewColumns: "View Columns",
		      filterTable: "Filter Table",
		    	},
		},
        selectableRows: 'none',
        customToolbar: () => <MakeToolbar />,
          onDownload: (buildHead, buildBody, columns, data) => {
			// Custom buildHead and buildBody functions
			const customBuildHead = () => {
				var newColumns = columns.map(column => column.label);
				return newColumns;
			}

			const customBuildBody = () => {
				const headers = customBuildHead();
				logger("headers", headers);
				for (var i=0; i < data.length; i++) {
					var d = data[i].data;
					for (var j = 0; j < d.length; j++) {
						var eachStr = d[j];
						if(eachStr && eachStr.includes("|")){
							var arr = eachStr.split("|");
							var str = "";
							for(var k=0; k<arr.length; k++){
								str = str+arr[k]+"\n";
							}
							logger("str",str);
							d[j] = str;
						}
					}
					data[i].data = d;
				}
				return customBodyForExcelReport({data:data, headers:headers});
			};

			const headers = customBuildHead();
			const rows = customBuildBody();
			handleExport({rows:rows, headers:headers, filename: 'BillingSOW.xlsx'});
			return false;
		}

    };
    const handleClickOpen = () => {

        setRefresh(true)
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setExpand(false);
    };
    React.useEffect(() => {
		checkAuthentication();
        if (refresh) {
         //   logger("expand" + expand)
            getData()

            setRefresh(false);
        }

    })

    options.onChangeRowsPerPage = (newRowsPerPage) => {
        saveRowsPerPage(newRowsPerPage);
    };

    return (
        <div className={classes.root}>
            <Button variant="contained" onClick={handleClickOpen}>
                SOW Billing
            </Button>
            <MuiThemeProvider theme={muiThemeDesign}>
                <Dialog className={classes.root} open={open} onClose={handleClose} fullWidth maxWidth="1400px" scroll="paper" overflow-y="hidden">
                    <DialogContent >
                        <Box>

                            <MUIDataTable className={classes.root}
                                title={

                                    <Typography variant="h6" style={{ color: "white" }}>
                                        <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close"> <CloseIcon /> </IconButton>
                                        SOW Billing History
                                    </Typography>
                                }
                                data={isLoading ? [] :dataSet}
                                columns={columns}
                                options={muiLoaderOptions(options, isLoading)}
                            />
                        </Box>
                    </DialogContent>
                </Dialog>
            </MuiThemeProvider>
        </div>
    );
}

 